


import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import requestService from "@/service/requestService";
import Number from "@/shared/filters/Number";
import { Utils } from "@/service/util";
import { CouponData } from "@/model/Coupon";
import { Getter, Action } from "vuex-class";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { UserService } from "@/service/UserService";
import loadingService from "@/service/loadingService";
import { MESSAGE } from "@/model/Message";
import TopBarTitle from "@/components/common/TopBarTitle.vue";
import InputNumber from "@/components/common/input/InputNumber.vue";
import OptionPageNex from "@/page/user/OptionPageNex.vue";
@Component({
  filters: {
    Number
  },
  components: {
    ConfirmDialog,
    TopBarTitle,
    InputNumber
  }
})
export default class QuickOptionComponentNex extends OptionPageNex {

  /** 2024-05-02 nextage [START] */
  @Getter("isNextageCustom", { namespace: "FunctionSetting" })
  isNextageCustom: any;
  /** 2024-05-02 nextage [END] */

  isModeModal: boolean = true;
  isModeQuick: boolean = false;

/** 2023-10-20 一時的な対応：簡単見積機能を税込税抜切り替え対象から外す [START] */
  @Prop() modeQuick: boolean;
  excludingFlg: boolean = false;
  excludingTex: string = "";
  loadingService: loadingService = new loadingService();
  public utils: Utils = new Utils();

  mounted() {
    this.$emit("onActiveSideTab", "soukouhosho");
    if (this.modeQuick) {
      this.excludingFlg = false;
      this.excludingTex = "税込";
      this.isModeQuick = this.modeQuick; // 一旦別フラグ扱いにする
    } else {
      if ( this.isExcludingTax ) { this.excludingFlg = true; }
      this.excludingTex = this.taxLabel;
      this.isModeQuick = this.modeQuick; // 一旦別フラグ扱いにする
    }
    this.menuReload();
  }
/** 2023-10-20 一時的な対応：簡単見積機能を税込税抜切り替え対象から外す [END] */

  onConfirm(isConfirm: number) {
    if (this.optionData) {
      if (this.optionData.option && this.optionData.option.items) {
        this.optionData.option.subTotalZk = this.subTotalZk;
        this.optionData.option.subTotalZn = this.subTotalZn;
      }
      this.setOption(this.optionData);
      let isConfirmCopied: any = isConfirm;
      if (isConfirm == 0) {
        isConfirmCopied = this.optionData.isConfirm;
      }
      if (this.optionDataForSave.option) {
        this.loadingService.show();
        this.reqService.saveOption({ // sendSocket:ソケット仮12
          options: this.optionDataForSave.option.items || []
          , sknUketsukeUserJouhou: { isConfirmOption: isConfirmCopied }
          , sknUketsukeExtendsId: this.uketsukeExtendsId
        }).then((res: any) => {
          this.autoSave(0);
          /** 2021-07-14 sh #7131 it get option from server after save.(quick mitsumori) [START] */
          // 手動で追加したオプションにIDが保持されないので、保存した後、再読み込みをする。
          // this.confirm(isConfirmCopied);
          const userService = new UserService();
          let promise = userService.getOptionPM();
          Promise.all([promise]).then(() => {
            this.loadingService.hide();
            this.confirm(isConfirmCopied);
            this.$emit("closeNext");
          }, (err) => {
            // ローディングだけは、止めておく
            this.loadingService.hide();
            this.$emit("closeNext");
          });
          /** 2021-07-14 sh #7131 it get option from server after save.(quick mitsumori) [END] */
        }, (error: any) => {
          this.loadingService.hide();
          this.$notify.error({
            title: "エラー",
            message: MESSAGE.SystemError
          });
          this.$emit("closeNext");
        });
      } else {
        this.autoSave(0);
        this.confirm(isConfirmCopied);
        this.$emit("closeNext");
      }
    }
  }

  onChangeOption(option?: any) {
    this.autoSave(1);
    this.onCheckChange(option);
  }
}
